<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    parentStoreName="Faqs"
    :submit="submit"
    :status="status"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row justify="center">
        <v-col cols="8">
          <v-row>
            <v-col>
              <v-autocomplete
                v-model="selected_users"
                :items="users"
                item-value="id"
                :item-text="(row)=>`${row.name || ''} ${row.last_name || ''}`"
                label="Usuarios"
                multiple
              >
                <template #prepend-item>
                  <v-list-item>
                    <v-list-item-action>
                      <v-checkbox
                        v-model="selectAll"
                        :indeterminate="selectAll === null"
                        :input-value="false"
                        hide-details
                        @click="clickSelectAllSearch(selectAll)"
                      ></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Seleccionar todos</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <template slot="no-data">
                  <v-alert :value="true"> No hay datos a mostrar </v-alert>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col>
              <ModalAssignUser
                :users="selected_items"
                @selected_users="getDataUsers"
              ></ModalAssignUser>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider
                ref="previous_amount"
                rules="required|numberpositivo"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.previous_amount"
                  label="Monto Anterior"
                  type="Number"
                  prepend-inner-icon="fas fa-user"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider
                ref="amount_acquired"
                rules="required|numberpositivo"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.amount_acquired"
                  label="Monto Adquirido"
                  type="Number"
                  prepend-inner-icon="fas fa-user"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider
                ref="current_amount"
                rules="required|numberpositivo"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.current_amount"
                  label="Monto Actual"
                  type="Number"
                  prepend-inner-icon="fas fa-user"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider
                ref="total_in_pesos"
                rules="required|numberpositivo"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.total_in_pesos"
                  label="Total en Pesos"
                  type="Number"
                  prepend-inner-icon="fas fa-user"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider
                ref="commission"
                rules="required|numberpositivo"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.commission"
                  label="Comision"
                  type="Number"
                  prepend-inner-icon="fas fa-user"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-menu
                ref="date_approved"
                v-model="menu_approved_date"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <ValidationProvider
                    ref="date_approved"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="data.date_approved"
                      label="Fecha de pago aprobado"
                      prepend-icon="fas fa-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </template>
                <v-date-picker
                  v-model="expire_date"
                  label="Fecha de pago aprobado"
                  type="date"
                  no-title
                  scrollable
                  @change="menu_approved_date = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
  import {ValidationProvider, ValidationObserver, extend} from "vee-validate";
  import {mapState} from 'vuex';
  import CrudForm from "@/components/Crud/CrudForm";
  import CrudFormMixin from '@/mixins/crud_form';

  extend('numberpositivo', {
    validate: value => {
      return value > 0;
    },
    message: 'El campo debe ser mayor a 0.'
  });

  extend('without_decimals', {
    validate: value => {
      return value % 1 === 0;
    },
    message: 'El valor no debe tener decimales'
  });

  export default {
    mixins: [CrudFormMixin],
    components: {ValidationProvider, ValidationObserver, CrudForm},
    computed: {
      ...mapState({
        status: state => state.Faqs.status,
      })
    },
    data() {
      return {
        storeName: 'Coin_purchases',
        title: "Compra de Coins",
        data: {
          user_id: '',
          previous_amount:'',
          amount_acquired:'',
          current_amount:'',
          total_in_pesos:'',
          commission:'',
          date_approved:''
        },
        menu_approved_date: false,
      }
    }
  }
</script>
